import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const RoleplayCompleteBody = dynamic(() => import('../../new-portal/ai-tutor/roleplay/complete'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const RoleplayCompleteActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const threadId = router.query?.threadId
  const roleplayId = router.query?.roleplayId

  return (
    <WebviewStackContainer height="0px" title={null} border={false}>
      <RoleplayCompleteBody threadId={threadId} roleplayId={roleplayId} />
    </WebviewStackContainer>
  )
}

export default RoleplayCompleteActivity
